import { render, staticRenderFns } from "./BowAmazon.vue?vue&type=template&id=1785a6aa"
import script from "./BowAmazon.vue?vue&type=script&lang=js"
export * from "./BowAmazon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports